import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useUser } from "../user";
import { PartialPreferences } from "./preferences";
import { PreferencesNotFoundError } from "./preferences-not-found-error";
import { usePreferencesFirestorePersistence } from "./use-preferences-firestore-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function usePreferencesFirestoreSwr() {
  const { user } = useUser();
  const { getPreferences } = usePreferencesFirestorePersistence();

  const fetchPreferences = async (
    key: [SwrStore, string],
  ): Promise<PartialPreferences | null> => {
    const userId = key[1];
    try {
      return await getPreferences(userId);
    } catch (error) {
      if (error instanceof PreferencesNotFoundError) return null;
      throw error;
    }
  };

  return useSWR(
    getSWRKey(SwrStore.FirestorePreferences, user.id),
    fetchPreferences,
    { suspense: true },
  );
}
